import { Boundaries } from "@planzone/core";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State } from "./types";

function handleSuccess(
  state: State,
  { groups, namespace }: Boundaries["retrieveResourceGroups"]["success"],
): State {
  return state.map((result) =>
    result.namespace === namespace
      ? {
          ...result,
          groups,
          request: setRequestStateToSuccess(),
        }
      : result,
  );
}

export { handleSuccess };
